// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json_decode from "../../../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";

function seasonDetailsDecoder(json) {
  return {
          season_title: Json_decode.field("season_title", Json_decode.string, json),
          season_points_title: Json_decode.field("season_points_title", Json_decode.string, json)
        };
}

function learnMoreModalDetailsDecoder(json) {
  return {
          title: Json_decode.field("title", Json_decode.string, json),
          content: Json_decode.field("content", Json_decode.string, json)
        };
}

function seasonalCampaignDecoder(json) {
  return {
          season_details: Json_decode.field("season_details", seasonDetailsDecoder, json),
          milestone_title: Json_decode.field("milestone_title", Json_decode.string, json),
          learn_more_header_title: Json_decode.field("learn_more_header_title", Json_decode.string, json),
          milestone_congratulations_text: Json_decode.field("milestone_congratulations_text", Json_decode.string, json),
          milestone_message_text: Json_decode.field("milestone_message_text", Json_decode.string, json)
        };
}

function pointsCollectedYesterdayTableDecoder(json) {
  return {
          title: Json_decode.field("title", Json_decode.string, json),
          login_hours_display_text: Json_decode.field("login_hours_display_text", Json_decode.string, json),
          order_fulfillment_display_text: Json_decode.field("order_fulfillment_display_text", Json_decode.string, json),
          order_rating_display_text: Json_decode.field("order_rating_display_text", Json_decode.string, json),
          footer_text: Json_decode.field("footer_text", Json_decode.string, json)
        };
}

function weeklyCampaignDecoder(json) {
  return {
          weekly_points_title: Json_decode.field("weekly_points_title", Json_decode.string, json),
          last_week_winners_and_prizes_title: Json_decode.field("last_week_winners_and_prizes_title", Json_decode.string, json),
          points_collected_yesterday_table: Json_decode.field("points_collected_yesterday_table", pointsCollectedYesterdayTableDecoder, json),
          learn_more_modal: Json_decode.field("learn_more_modal", learnMoreModalDetailsDecoder, json),
          week_title: Json_decode.field("week_title", Json_decode.string, json)
        };
}

function pointsClaimContentDecoder(json) {
  return {
          title: Json_decode.field("title", Json_decode.string, json),
          yesterday_points_title: Json_decode.field("yesterday_points_title", Json_decode.string, json),
          expires_in_prefix: Json_decode.field("expires_in_prefix", Json_decode.string, json),
          claim_prefix: Json_decode.field("claim_prefix", Json_decode.string, json)
        };
}

function execute(json) {
  return {
          seasonal_campaign: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "seasonal_campaign",
                      tl: /* [] */0
                    }
                  }
                }, seasonalCampaignDecoder)(json),
          weekly_campaign: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "weekly_campaign",
                      tl: /* [] */0
                    }
                  }
                }, weeklyCampaignDecoder)(json),
          points_claim_sticky_section: Json_decode.at({
                  hd: "data",
                  tl: {
                    hd: "attributes",
                    tl: {
                      hd: "points_claim_sticky_section",
                      tl: /* [] */0
                    }
                  }
                }, pointsClaimContentDecoder)(json)
        };
}

export {
  seasonDetailsDecoder ,
  learnMoreModalDetailsDecoder ,
  seasonalCampaignDecoder ,
  pointsCollectedYesterdayTableDecoder ,
  weeklyCampaignDecoder ,
  pointsClaimContentDecoder ,
  execute ,
  
}
/* No side effect */
